import { render, staticRenderFns } from "./PreviousPlansCard.vue?vue&type=template&id=1dd8ddba&scoped=true"
import script from "./PreviousPlansCard.vue?vue&type=script&lang=ts"
export * from "./PreviousPlansCard.vue?vue&type=script&lang=ts"
import style0 from "./PreviousPlansCard.vue?vue&type=style&index=0&id=1dd8ddba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8ddba",
  null
  
)

export default component.exports